document.addEventListener('DOMContentLoaded', function() {
  const quickviewModal = document.getElementById('quickview-modal');
  const quickviewClose = document.querySelector('.quickview-close');
  const quickviewContainer = document.querySelector('.quickview-container');
  const focusTrap = window.ThemeFocusTrap && quickviewModal
    ? new window.ThemeFocusTrap(quickviewModal, {
        initialFocus: '.quickview-close',
        onEscape: closeQuickview
      })
    : null;
  const productCache = new Map();
  let activeRequest = null;
  
  // Default translations - can be overridden by window.quickviewTranslations
  const defaultTranslations = {
    loading: 'Učitava...',
    add_to_cart: 'Dodaj u korpu',
    sold_out: 'Rasprodano',
    unavailable: 'Nedostupno',
    out_of_stock: 'Nema na stanju',
    view_product: 'Pogledaj sve detalje',
    size: 'Veličina',
    color: 'Boja',
    error_loading: 'Greška pri učitavanju proizvoda. Pokušajte ponovo.',
    close: 'Zatvori brzi pregled',
    product: 'Proizvod'
  };
  
  function getTranslation(key) {
    return (window.quickviewTranslations && window.quickviewTranslations[key]) || defaultTranslations[key] || key;
  }

  function getStorefrontUrl(path) {
    const rootUrl = window.routes && window.routes.root_url ? window.routes.root_url : '/';
    return `${rootUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  }
  
  function textFromHtml(html) {
    const element = document.createElement('div');
    element.innerHTML = html || '';
    return (element.textContent || '').trim();
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = String(value ?? '');
    return element.innerHTML;
  }

  function normalizeProduct(product, handle) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const options = (Array.isArray(product.options) ? product.options : []).map((option, index) => {
      const name = typeof option === 'string' ? option : option.name;
      const optionValues = Array.isArray(option.values)
        ? option.values
        : [...new Set(variants.map((variant) => variant.options?.[index]).filter(Boolean))];

      return {
        name: name || `Option ${index + 1}`,
        values: optionValues.map((value) => {
          const normalizedValue = typeof value === 'string' ? value : value.name;
          return { value: normalizedValue, text: normalizedValue };
        })
      };
    });

    const description = textFromHtml(product.description)
      .split(/\s+/)
      .slice(0, 30)
      .join(' ');

    return {
      ...product,
      handle,
      category: product.type || '',
      description,
      options,
      variants,
      featured_image: typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image?.src || '',
      price: window.formatMoney ? window.formatMoney(product.price) : String(product.price || '')
    };
  }
  
  function openQuickview(productHandle) {
    if (!productHandle) return;
    
    quickviewContainer.innerHTML = `
      <div class="quickview-loading"></div>
    `;
    
    // Show modal immediately with loading state
    quickviewModal.style.display = 'flex';
    quickviewModal.setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      quickviewModal.classList.add('active');
      focusTrap?.activate();
    }, 10);
    
    document.body.style.overflow = 'hidden';
    
    loadProductData(productHandle);
  }
  
  function closeQuickview() {
    if (quickviewModal.getAttribute('aria-hidden') === 'true') return;

    activeRequest?.abort();
    activeRequest = null;
    
    quickviewModal.style.display = 'none';
    quickviewModal.classList.remove('active');
    quickviewModal.setAttribute('aria-hidden', 'true');
    focusTrap?.deactivate();
    
    setTimeout(() => {
      if (quickviewModal) {
        quickviewModal.style.display = 'none';
        quickviewContainer.innerHTML = '';
      }
    }, 300);
    
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  
  quickviewModal.addEventListener('click', function(e) {
    if (e.target === quickviewModal) {
      closeQuickview();
    }
  });
  
  if (quickviewClose) {
    quickviewClose.addEventListener('click', closeQuickview);
  }
  
  function loadProductData(handle) {
    if (productCache.has(handle)) {
      renderQuickview(productCache.get(handle));
      return;
    }

    activeRequest?.abort();
    activeRequest = new AbortController();
    const request = activeRequest;

    fetch(getStorefrontUrl(`products/${encodeURIComponent(handle)}.js`), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: request.signal
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then(product => {
        const productData = normalizeProduct(product, handle);
        productCache.set(handle, productData);

        if (quickviewModal.getAttribute('aria-hidden') === 'false') {
          renderQuickview(productData);
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') return;

        quickviewContainer.innerHTML = `
          <div class="quickview-error">
            <p>${getTranslation('error_loading')}</p>
            <button type="button" class="button button--secondary" onclick="closeQuickview()">${getTranslation('close')}</button>
          </div>
        `;
      })
      .finally(() => {
        if (activeRequest === request) activeRequest = null;
      });
  }
  
  function renderQuickview(product) {
    const productUrl = getStorefrontUrl(`products/${product.handle}`);
    const productTitle = escapeHtml(product.title || getTranslation('product'));
    const productCategory = escapeHtml(product.category);
    const productDescription = escapeHtml(product.description);
    const featuredImage = escapeHtml(product.featured_image);
    const productPrice = escapeHtml(product.price);
    
    let html = `
      <div class="quickview-images">
        <a href="${productUrl}" class="quickview-image-link">
          <div class="quickview-main-image">
            <img id="quickview-featured-image" src="${featuredImage}" alt="${productTitle}" loading="eager" fetchpriority="high" />
          </div>
        </a>
      </div>
      <div class="quickview-details">
        ${productCategory ? `<p class="quickview-eyebrow">${productCategory}</p>` : ''}
        <h2 class="quickview-title" id="quickview-title">
          <a href="${productUrl}" class="quickview-title-link">${productTitle}</a>
        </h2>
        <div class="quickview-price-wrapper">
          <span class="compare-at-price quickview-price" id="quickview-compare-price" style="display: none;"></span>
          <span class="quickview-price" id="quickview-price">${productPrice}</span>
        </div>
        
        <div class="quickview-variants">
          ${renderVariantOptions(product)}
        </div>
        
        <div class="quickview-form">
          <form method="post" action="${getStorefrontUrl('cart/add')}" id="quickview-product-form" class="product-form">
            <input type="hidden" name="id" id="quickview-variant-id" value="">
          
            <button type="submit" name="add" class="button button--primary quickview-add-to-cart js-go-cart-add-to-cart" id="quickview-add-to-cart" disabled>
              <span>${getTranslation('add_to_cart')}</span>
            </button>

          </form>
        </div>
        
        ${productDescription ? `<div class="quickview-description">${productDescription}</div>` : ''}
        <a href="${productUrl}" class="button--link quickview-view-details">${getTranslation('view_product')}</a>
      </div>
    `;
    
    quickviewContainer.innerHTML = html;
    
    initVariantSelection(product);
    
    document.dispatchEvent(new CustomEvent('quickview:loaded'));
    
    const quickviewForm = document.querySelector('#quickview-product-form');
    if (quickviewForm) {
      quickviewForm.addEventListener('submit', (event) => {
        const variant = quickviewForm.querySelector('[name="id"]');
        if (!variant.value || variant.disabled || quickviewForm.querySelector('[name="add"]').disabled) {
          event.preventDefault();
        }
      });
      quickviewForm.addEventListener('cart:item-added', closeQuickview, { once: true });
    }

  }
  
  function renderVariantOptions(product) {
    if (!product.options || product.options.length === 0) return '';
    
    let html = '';
    const defaultVariant = product.variants && product.variants.find(variant => variant.available) || product.variants && product.variants[0];
    
    product.options.forEach((option, index) => {
      const optionName = option.name.replace('option', '');
      const isColor = optionName.toLowerCase().includes('boja') || optionName.toLowerCase().includes('color');
      const isSize = optionName.toLowerCase().includes('veličina') || optionName.toLowerCase().includes('size');
      
      const displayName = escapeHtml(isSize ? getTranslation('size') : (isColor ? getTranslation('color') : optionName));
      
      html += `
        <fieldset class="product-form__input product-form__input--pill ${isColor ? 'color' : (isSize ? 'size' : '')}">
          <legend class="form__label">
            <span>${displayName}</span>
            ${isSize ? '' : `<span class="value-selected" id="value-selected-${index}"></span>`}
          </legend>
          <div class="input-selector-wrapper">
      `;
      
      option.values.forEach((value, valueIndex) => {
        const inputId = `quickview-option-${index}-${valueIndex}`;
        const isSelected = defaultVariant && defaultVariant.options && defaultVariant.options[index] === value.value;
        const isAvailable = !product.variants || product.variants.some(variant => variant.available && variant.options && variant.options[index] === value.value);
        const optionValue = escapeHtml(value.value);
        const optionText = escapeHtml(value.text);
        
        let colorValue = null;
        if (isColor && product.variants) {
          const variant = product.variants.find(v => v.options && v.options[index] === value.value);
          if (variant && variant.color) {
            colorValue = variant.color;
          }
        }
        
        html += `
          <div class="input-selector ${isColor ? 'color' : ''} ${isSize ? 'size' : ''}">
            <input type="radio" 
                  id="${inputId}" 
                  name="option-${index}" 
                  value="${optionValue}"
                  data-text="${optionText}"
                  ${isSelected || (!defaultVariant && valueIndex === 0) ? 'checked' : ''}
                  class="${isAvailable ? '' : 'disabled'}"
                  ${isAvailable ? '' : 'aria-disabled="true"'}>
            <label for="${inputId}" class="product-variant-label ${colorValue ? 'has-color' : ''}" ${colorValue ? `style="background: ${escapeHtml(colorValue)};" aria-label="${optionText}" title="${optionText}"` : ''}>
              ${colorValue ? `<span class="visually-hidden">${optionText}</span>` : `<span class="variant-size">${optionText}</span>`}
            </label>
          </div>
        `;
      });
      
      html += `
          </div>
        </fieldset>
      `;
    });
    
    return html;
  }
  
  function initVariantSelection(product) {
    if (!product.variants || product.variants.length === 0) return;
    
    const variantRadios = document.querySelectorAll('.quickview-container .input-selector input[type="radio"]');
    const variantIdInput = document.getElementById('quickview-variant-id');
    const addToCartBtn = document.getElementById('quickview-add-to-cart');
    const priceElement = document.getElementById('quickview-price');
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateVariantSelection);
    });
    
    function updateVariantSelection() {
      const selectedValues = [];
      
      document.querySelectorAll('.quickview-container .input-selector-wrapper').forEach((wrapper, index) => {
        const selectedRadio = wrapper.querySelector('input[type="radio"]:checked');
        const valueSelectedSpan = document.getElementById(`value-selected-${index}`);
        
        if (selectedRadio) {
          selectedValues.push(selectedRadio.value);
          if (valueSelectedSpan) {
            valueSelectedSpan.textContent = selectedRadio.dataset.text || selectedRadio.value;
          }
        }
      });
      
      const selectedVariant = product.variants.find(variant => {
        return variant.options && variant.options.every((option, index) => {
          return option === selectedValues[index];
        });
      });

      if (selectedVariant) {
        if (variantIdInput) {
          variantIdInput.value = selectedVariant.id;
          variantIdInput.disabled = !selectedVariant.available;
        }
        
        if (priceElement) {
          if (selectedVariant.price != null) {
            priceElement.textContent = window.formatMoney ? window.formatMoney(selectedVariant.price) : selectedVariant.price;
          }
          
          const comparePriceElement = document.getElementById('quickview-compare-price');
          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            comparePriceElement.textContent = window.formatMoney ? window.formatMoney(selectedVariant.compare_at_price) : selectedVariant.compare_at_price;
            comparePriceElement.style.display = 'inline';
            comparePriceElement.style.textDecoration = 'line-through';
            comparePriceElement.style.opacity = '0.7';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        
        // Handle variant image switching
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          updateQuickviewImages(selectedVariant.featured_image, product.media);
        }
        
        if (addToCartBtn) {
          if (selectedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.querySelector('span').textContent = getTranslation('add_to_cart');
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.querySelector('span').textContent = getTranslation('sold_out');
          }
        }
      } else {
        if (variantIdInput) {
          variantIdInput.value = '';
          variantIdInput.disabled = true;
        }
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.querySelector('span').textContent = getTranslation('unavailable');
        }
      }
    }
    
    updateVariantSelection();
  }

  // New function to update quickview images when variant changes
  function updateQuickviewImages(variantImage, allMedia) {
    if (!variantImage || !variantImage.src) return;
    
    // Update main featured image
    const featuredImage = document.getElementById('quickview-featured-image');
    if (featuredImage) {
      featuredImage.src = variantImage.src;
      featuredImage.srcset = `${variantImage.src} 1x, ${variantImage.src} 2x`;
    }
  }

  window.openQuickview = function(productHandle) {
    openQuickview(productHandle);
  };
  
  window.closeQuickview = closeQuickview;
});
